import { ChangeDetectionStrategy, Component, OnInit, ViewChild } from "@angular/core";
import { Router } from "@angular/router";
import { AuthService } from "../../../auth/auth.service";
import { PopoverComponent } from "../../../shared/panel/popover/popover.component";
import { StringHelper } from "../../../utilities/contracts/string-helper";

@Component({
  selector: "platform-account-menu",
  templateUrl: "./account-menu.component.html",
  styleUrls: ["./account-menu.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AccountMenuComponent implements OnInit {
  @ViewChild("popover", { static: true }) private popover: PopoverComponent;
  backgroundClass = "user-circle ";

  constructor(
    private router: Router,
    private authService: AuthService
  ) { }


  ngOnInit() {
    this.getRandomBackgroundColor();
  }

  get username(): string {
    return this.authService.username;
  }

  get activeClass(): string {
    return this.popover.visible ? "username__container--active" : "";
  }

  logout(): void {
    this.authService.logout();
  }

  get organizationName(): string {
    return this.authService.userOrganizationName;
  }

  get initialUserFirstName(): string {
    const firstName = this.authService.userFirstName;
    if (StringHelper.isAvailable(firstName)) {
      return firstName.charAt(0).toUpperCase();
    }
    return "";
  }

  get initialUserLastName(): string {
    const lastName = this.authService.userLastName;
    if (StringHelper.isAvailable(lastName)) {
      return lastName.charAt(0).toUpperCase();
    }
    return "";
  }

  getRandomBackgroundColor(): void {
    const colors = ["--red-circle", "--teal-circle", "--yellow-circle", "--navy-circle", "--pink-circle"];
    const randomColor = Math.floor(Math.random() * colors.length);
    this.backgroundClass += colors[randomColor];
  }
}
